import { VIGUEUR_DIFF } from '../../../../../../../shared/constants/legislationArticleApplicability';
import { StateType } from '../../../../../state/state.types';

export function makeLawEventData(
  law: NonNullable<StateType['results']['snippets']['law']>,
) {
  return {
    title: law.title,
    parent_text_nature: law.parentTextNature,
    parent_text_short_title: law.parentTextShortTitle,
    clean_number: law.cleanNumber,
    article_id: law.articleId,
    text_length: law.text.length,
  };
}

export function convertDateLawVersion({
  start,
  end,
  state,
}: {
  start: string | null;
  end: string | null;
  state?: string | null;
}) {
  let stringFormated = 'Version ';

  if (state === VIGUEUR_DIFF) {
    stringFormated += `à partir du ${start}`;
    return stringFormated;
  }

  if (end == null) {
    stringFormated += 'depuis le';
  } else {
    stringFormated += 'du';
  }
  stringFormated += ` ${start} `;
  if (end != null) {
    stringFormated += `au ${end}`;
  }
  return stringFormated;
}
